module.exports = "<p>\n  tiny-mce works!\n</p>\n  <span\n    class=\"help-block text-muted\"\n    *ngIf=\"input.description!=''\"\n  >{{ input.description }}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ing-dynamic-form/dynamic-form/tiny-mce/tiny-mce.component.html
// module id = 1316
// module chunks = 4